import BaseIconSvg from '@/components/bases/BaseIconSvg';
import * as React from 'react';

export interface INoDataYetProps {}

export default function NoDataYet(props: INoDataYetProps) {
  return (
    <div className="text-gray-7 h-full w-full flex justify-center items-center">
      <div>
        <div className="flex justify-center">
          <BaseIconSvg className="wh-[48px]" src="/icons/File.svg" />
        </div>
        <div className="flex justify-center">
          <div>Chưa có dữ liệu</div>
        </div>
      </div>
    </div>
  );
}
